import { request } from './index'

/**
 * 统一业务网关调用
 * @param {string} model - 控制器名，如 alarm / sensor
 * @param {string} func - 方法名，如 get_alarm_list
 * @param {object} args - 参数
 */
export const api = (model, func, args = {}) => {
  return request.put('', { model, func, args: args || {} })
}

export const user = {
  login: (p) => request.post('/login', p),
  register: (p) => request.post('/register', p),
}

export const wechat = {
  /** 微信静默登录（仅 snsapi_base 回调，按 openid 查绑定） */
  silentLogin: (p) => request.post('/wechat/silent-login', p),
  /** 微信 userinfo 登录（snsapi_userinfo 回调，按 unionid 再查绑定） */
  userinfoLogin: (p) => request.post('/wechat/union-login', p),
  /** 微信授权绑定并登录（openid/unionid + 账号密码） */
  bindLogin: (p) => request.post('/wechat/bind-login', p),
}
